<div class="col-md-12">
  <div class="row mb-3">
    <div class="col-md-8">
      <span class="badge badge-primary">{{ factures?.length || 0 }} facture(s)</span>
    </div>
    <div class="col-md-4 text-right">
      <button class="btn btn-primary btn-sm" (click)="addFacture()">
        <i class="feather icon-plus"></i> Ajouter
      </button>
    </div>
  </div>
  <div class="table-responsive">
    <table datatable [dtOptions]="dtOptions" class="table table-sm table-striped table-bordered nowrap table-hover">
      <thead class="thead-light">
        <tr>
          <th>Code</th>
          <th>Libellé</th>
          <th>Type</th>
          <th>Copropriétaire</th>
          <th>Montant total</th>
          <th>Payé</th>
          <th>Restant</th>
          <th>Statut</th>
          <th>Échéance</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of factures">
          <td>{{ item?.code }}</td>
          <td>{{ item?.libelle }}</td>
          <td>
            <span class="badge" [ngClass]="item?.type === 'DEBIT' ? 'badge-danger' : 'badge-success'">
              {{ item?.type }}
            </span>
          </td>
          <td>{{ item?.ownerCo?.nomComplet }}</td>
          <td class="text-right">{{ item?.montantTotal | number:'1.0-0' }} FCFA</td>
          <td class="text-right text-success">{{ item?.montantPaye | number:'1.0-0' }} FCFA</td>
          <td class="text-right text-danger">{{ item?.montantRestant | number:'1.0-0' }} FCFA</td>
          <td>
            <span class="badge" [ngClass]="{
              'badge-secondary': item?.statut === 'BROUILLON',
              'badge-info': item?.statut === 'EMISE',
              'badge-warning': item?.statut === 'PAYE_PARTIELLEMENT',
              'badge-success': item?.statut === 'PAYE',
              'badge-danger': item?.statut === 'ANNULE'
            }">{{ item?.statut }}</span>
          </td>
          <td>{{ item?.dateEcheance }}</td>
          <td class="text-center">
            <button class="btn btn-icon btn-outline-primary btn-sm mr-1" title="Modifier" (click)="editFacture(item)">
              <i class="feather icon-edit-2"></i>
            </button>
            <button *ngIf="item?.isDelete" class="btn btn-icon btn-outline-danger btn-sm" title="Supprimer" (click)="deleteFacture(item)">
              <i class="feather icon-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
